module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "textcenter"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm04_copy"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v("NEW YORK UNIVERSITY PRESS"), _c('br'), _vm._v("New York and London"), _c('br'), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.nyupress.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nyupress.org")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter1"
  }, [_vm._v("© 2003 by New York University"), _c('br'), _vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _vm._v("McDaniel, Patricia (Patricia A.)")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Shrinking violets and Caspar Milquetoasts :"), _c('br'), _vm._v("shyness, power, and intimacy in the United States, 1950–1995/"), _c('br'), _vm._v("Patricia McDaniel.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("p. cm. — (The American social experience series)"), _c('br'), _vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("ISBN 0–8147–5677–8 (alk. paper) — ISBN 0–8147–5678–6 (pbk. : alk. paper)"), _c('br'), _vm._v("1. Bashfulness—History. 2. Bashfulness—Social aspects—United States.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("I. Title.  II. Series.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("BF575.B3M34 2003")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("155.2’32—dc21         2003011890")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter1"
  }, [_vm._v("New York University Press books are printed on acid-free paper,"), _c('br'), _vm._v("and their binding materials are chosen for strength and durability.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter1"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter1"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12612b6d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04_copy.vue
// module id = 66
// module chunks = 0